import React, { useState } from 'react';
import { useMutation } from 'react-query';
import { postConversation } from '../../api/get';
import { useSelector } from 'react-redux';
import { LoadingOverlay } from '@mantine/core';

const Help = ({ setChosenMenuItem }) => {
	const { user } = useSelector((store) => store.auth);

	const [form, setForm] = useState({
		title: '',
		content: '',
		files: [],
	});

	const createConvMutation = useMutation(postConversation, {
		onSuccess: () => {
			setChosenMenuItem('Korespondencja');
		},
	});

	const handleSubmit = (e) => {
		e.preventDefault();
		createConvMutation.mutate({
			...form,
			clientReceiver: user.userId,
		});
	};

	return (
		<div
			className="white-box white-box--larger"
			style={{
				position: 'relative',
			}}
		>
			<LoadingOverlay visible={createConvMutation.isLoading} />
			<div className="white-box__inner">
				<h2 className="main-title main-title--25 main-title--mb-45">
					Potrzebujesz pomocy?
				</h2>

				<div className="row no-gutters">
					<div className="col-md-6 col-lg-6 col-xlg-5">
						<div className="contact-help-wrapper">
							<h3 className="main-title-heading">ZADZWOŃ LUB NAPISZ</h3>

							<div className="contact-item">
								<span className="icon">
									<i className="ico ico-phone-icon"></i>
								</span>
								<a href="tel:+48123456789" className="link">
									+48 123 456 789
								</a>
							</div>

							<div className="contact-item">
								<span className="icon">
									<i className="ico ico-mail-icon"></i>
								</span>
								<a href="mailto:kontakt@gettimages.pl" className="link">
									kontakt@gettimages.pl
								</a>
							</div>
						</div>
					</div>

					<div className="col-md-6 col-lg-6 col-xlg-5 col-xlg-offset-1">
						<h3 className="main-title-heading">WYPEŁNIJ FORMULARZ</h3>

						<form onSubmit={handleSubmit}>
							<div className="form__group">
								<div className="form__field">
									<input
										value={form.title}
										onChange={(e) => {
											setForm({
												...form,
												title: e.target.value,
											});
										}}
										type="text"
										name="f-default-2"
										placeholder="Temat wiadomości"
										className="form__input required"
										id="f-default-2"
									/>
								</div>
							</div>
							<div className="form__group">
								<div className="form__field">
									<textarea
										value={form.content}
										onChange={(e) => {
											setForm({
												...form,
												content: e.target.value,
											});
										}}
										name="f-horizontal-15"
										rows={5}
										className="form__input"
										id="f-horizontal-15"
										placeholder="Treść wiadomości"
									></textarea>
								</div>
							</div>
							<div className="form__actions mt-10">
								<button className="btn btn--block">Wyślij wiadomość</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Help;
